export default "__VITE_ASSET__BUfsjLx3__"